export const language = {
  en: {
    "Buyer": "Buyer",
    "Supplier Center": "Supplier Center",
    'Hello': "Hello",
    'Search': "Search",
    'QUOTE': "QUOTE",
    'BID': "BID",
    'REPLY': "REPLY",
    "Business Chance Invitation": "Business Chance Invitation",
    "Please Enter A Keyword": "Please Enter A Keyword",
    'Participate': "Participate",
    "Buy Time": "Buy Time",
    "Import and Export Documents": "Import and Export Documents",
    "No Data": "No Data",
    "Message Center": "Message Center",
    "Hello, you have": "Hello, you have",
    "Purchase Order needs to be confirmed": "Purchase Order needs to be confirmed",
    "VIEW MORE": 'VIEW MORE',
    'Inquiry List To Be Answered': 'Inquiry List To Be Answered',
  },
  zh: {
    "Buyer": "采购方",
    "Supplier Center": "供应商中心",
    'Hello': "你好",
    'Search': "搜索",
    'QUOTE': "待报价",
    'BID': "待竞价",
    'REPLY': "待回复",
    "Business Chance Invitation": "商机推荐",
    'Participate': "参与报价",
    'Please Enter A Keyword': '请输入关键词',
    'Import and Export Documents': '进出口单据服务',
    "No Data": "暂无数据",
    "Buy Time": "采购时间",
    "Message Center": "消息中心",
    "Hello, you have": "您好,你有",
    "Purchase Order needs to be confirmed": "个采购单需要确认",
    "VIEW MORE": '查看更多',
    'Inquiry List To Be Answered': '询价单待回复'
  },
};
